/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import ToolTip from '../../../../../elements/ToolTip';

function DoubleCurrencyField({
  fieldName,
  accountField,
  baseField,
  label,
  tooltip,
  optionalText,
  placeholderAccount,
  placeholderBase,
  errors,
  register,
  watch,
  accountCurrency,
  isBaseCurrencySameAsAccountCurrency,
  baseCurrency,
  accountValidation,
  baseValidation,
  className,
  accountTabIndex,
  baseTabIndex,
  labelClassName,
}) {
  const resolvedAccountField = accountField || (fieldName ? `${fieldName}Quote` : '');
  const resolvedBaseField = baseField || (fieldName ? `${fieldName}QuoteBaseCurrency` : '');
  const displayLabel = label || fieldName || '';

  const accountError = errors?.[resolvedAccountField];
  const baseError = errors?.[resolvedBaseField];
  const hasError = Boolean(accountError || baseError);

  return (
    <div className={className}>
      <div className="flex gap-1 items-start justify-between">
        <label htmlFor={resolvedAccountField} className={`text-sm font-medium whitespace-pre-line ${labelClassName || 'text-gray-700'}`}>
          {displayLabel}
          {tooltip && <ToolTip formatting="inline-block -mb-1" info={tooltip} />}
        </label>
        {optionalText && <span className="text-sm text-gray-500">{optionalText}</span>}
      </div>
      <div className="mt-1 relative">
        <div className="grid grid-cols-2 gap-2">
          <div className="flex items-center gap-2">
            <input
              id={resolvedAccountField}
              type="number"
              autoComplete="off"
              name={resolvedAccountField}
              className={`block w-full focus:outline-none sm:text-sm rounded-md bg-white ${
                hasError
                  ? 'border-red-300 text-red-900 placeholder-red-300 focus:ring-red-500 focus:border-red-500'
                  : 'border-gray-300 placeholder-gray-400 focus:ring-brandBlue-500 focus:border-brandBlue-500'
              }`}
              placeholder={placeholderAccount}
              tabIndex={accountTabIndex}
              {...register(resolvedAccountField, accountValidation)}
            />
            <span className="text-xs xs:text-sm whitespace-nowrap">{accountCurrency || '?'}</span>
          </div>
          {!isBaseCurrencySameAsAccountCurrency && (
            <div className="flex items-center gap-2">
              <input
                id={resolvedBaseField}
                type="number"
                autoComplete="off"
                name={resolvedBaseField}
                className={`block w-full focus:outline-none sm:text-sm rounded-md bg-white ${
                  hasError
                    ? 'border-red-300 text-red-900 placeholder-red-300 focus:ring-red-500 focus:border-red-500'
                    : 'border-gray-300 placeholder-gray-400 focus:ring-brandBlue-500 focus:border-brandBlue-500'
                }`}
                placeholder={placeholderBase || placeholderAccount}
                tabIndex={baseTabIndex}
                {...register(resolvedBaseField, baseValidation)}
              />
              <span className="text-xs xs:text-sm whitespace-nowrap">{baseCurrency}</span>
            </div>
          )}
        </div>
      </div>
      {(accountError || baseError) && <p className="mt-2 text-sm text-red-600">{accountError?.message || baseError?.message}</p>}
    </div>
  );
}

DoubleCurrencyField.propTypes = {
  fieldName: PropTypes.string,
  accountField: PropTypes.string,
  baseField: PropTypes.string,
  label: PropTypes.string,
  tooltip: PropTypes.string,
  optionalText: PropTypes.string,
  placeholderAccount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  placeholderBase: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  errors: PropTypes.object.isRequired,
  register: PropTypes.func.isRequired,
  watch: PropTypes.func.isRequired,
  accountCurrency: PropTypes.string,
  isBaseCurrencySameAsAccountCurrency: PropTypes.bool.isRequired,
  baseCurrency: PropTypes.string.isRequired,
  accountValidation: PropTypes.object,
  baseValidation: PropTypes.object,
  className: PropTypes.string,
  accountTabIndex: PropTypes.number,
  baseTabIndex: PropTypes.number,
  labelClassName: PropTypes.string,
};

DoubleCurrencyField.defaultProps = {
  fieldName: '',
  tooltip: '',
  optionalText: 'Optional',
  placeholderAccount: '250',
  placeholderBase: null,
  accountCurrency: '',
  accountValidation: undefined,
  baseValidation: undefined,
  className: '',
  accountField: '',
  baseField: '',
  label: '',
  accountTabIndex: undefined,
  baseTabIndex: undefined,
  labelClassName: '',
};

export default DoubleCurrencyField;
